const CLEAR_TABLE = 'CLEAR_TABLE';
const FETCH_EDITOR_OPTIONS_SUCCESS = 'FETCH_EDITOR_OPTIONS_SUCCESS';
const FETCH_EDITOR_OPTIONS_FAILURE = 'FETCH_EDITOR_OPTIONS_FAILURE';
const UPDATE_TABLE_REQUEST = 'UPDATE_TABLE_REQUEST';
const UPDATE_TABLE_SUCCESS = 'UPDATE_TABLE_SUCCESS';
const UPDATE_TABLE_FAILURE = 'UPDATE_TABLE_FAILURE';

const PAGE_SIZE = 50;

export {
  CLEAR_TABLE,
  FETCH_EDITOR_OPTIONS_SUCCESS,
  FETCH_EDITOR_OPTIONS_FAILURE,
  UPDATE_TABLE_REQUEST,
  UPDATE_TABLE_SUCCESS,
  UPDATE_TABLE_FAILURE,
  PAGE_SIZE,
};
